import { z } from 'zod/v4';

export const baseMessageSchema = z.object({
  message: z.string(),
  eventType: z.string(),
});

export type BaseMessage = z.infer<typeof baseMessageSchema>;
